import { Injectable } from '@angular/core';
import { AppNotificationUtilClass, Organizi8DataProvider } from '@monorepo/services';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  ClearAndFetchFabricStorageGRNDetails,
  ClearAndFetchFabricStorageGRNDetailsSuccess,
  ClearAndFetchTrimsStorageGRNDetails,
  ClearAndFetchTrimsStorageGRNDetailsSuccess,
  ClearAndFetchFabricStorageRollsDetails,
  ClearAndFetchFabricStorageRollsDetailsSuccess,
  ClearAndFetchTrimsStorageItemDetails,
  ClearAndFetchTrimsStorageItemDetailsSuccess,
  StorageDBActions,
  StorageNoAction,
} from './storage.actions';
import { catchError, finalize, map, switchMap, take } from 'rxjs/operators';
import { from, of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class StorageDBEffects {
  constructor(
    private actions$: Actions,
    private apiHelper: AppNotificationUtilClass,
    private organizi8DataProvider: Organizi8DataProvider,
    private translate: TranslateService,
  ) {}

  ClearAndFetchFabricStorageGRNDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchFabricStorageGRNDetails>(StorageDBActions.ClearAndFetchFabricStorageGRNDetails),
      switchMap((action) =>
        from(
          this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.getting_fabric_grn_details')),
        ).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getFabricStorageGRNDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchFabricStorageGRNDetailsSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_FABRIC_STORAGE_GRN_DETAILS_ERROR]', error);
            return of(new StorageNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchTrimsStorageGRNDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchTrimsStorageGRNDetails>(StorageDBActions.ClearAndFetchTrimsStorageGRNDetails),
      switchMap((action) =>
        from(
          this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.getting_trims_grn_details')),
        ).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getTrimsStorageGRNDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchTrimsStorageGRNDetailsSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_TRIMS_STORAGE_GRN_DETAILS_ERROR]', error);
            return of(new StorageNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchFabricStorageRollsDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchFabricStorageRollsDetails>(StorageDBActions.ClearAndFetchFabricStorageRollsDetails),
      switchMap((action) =>
        from(
          this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.getting_fabric_roll_details')),
        ).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getFabricStorageRollsDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchFabricStorageRollsDetailsSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_FABRIC_ROLLS_DETAILS_ERROR]', error);
            return of(new StorageNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );

  ClearAndFetchTrimsStorageItemDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ClearAndFetchTrimsStorageItemDetails>(StorageDBActions.ClearAndFetchTrimsStorageItemDetails),
      switchMap((action) =>
        from(
          this.apiHelper.presentLoading(this.translate.instant('organizi8_ngrx_store.getting_trims_item_details')),
        ).pipe(
          take(1),
          map((loaderEl) => [loaderEl, action.payload] as const),
        ),
      ),
      switchMap(([loaderEl, payload]) =>
        this.organizi8DataProvider.getTrimsStorageItemsDetails(payload).pipe(
          take(1),
          map((res) => new ClearAndFetchTrimsStorageItemDetailsSuccess(res)),
          catchError((error) => {
            console.log('[CLEAR_AND_FETCH_TRIMS_ITEMS_DETAILS_ERROR]', error);
            return of(new StorageNoAction());
          }),
          finalize(() => this.apiHelper.dismissLoadingV2(loaderEl)),
        ),
      ),
    ),
  );
}
